module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-col page"
  }, [_c('div', {
    staticClass: "flex-col group_3"
  }, [_c('div', {
    staticClass: "flex-col group_4"
  }, [_c('div', {
    staticClass: "flex-col items-center"
  }, [_c('span', {
    staticClass: "text_3"
  }, [_vm._v(_vm._s(_vm.couponDetail.couponName))]), _vm._v(" "), _c('span', {
    staticClass: "text_4"
  }, [_vm._v("有效期：" + _vm._s(_vm.formatTime(_vm.couponDetail.effectTime)) + " 至\n                    " + _vm._s(_vm.formatTime(_vm.couponDetail.expireTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-col group_6"
  }, [_c('div', {
    staticClass: "flex-col section_1"
  }, [_c('div', {
    staticClass: "justify-between group_7"
  }, [_c('span', {
    staticClass: "text_5"
  }, [_vm._v("券码")]), _vm._v(" "), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(_vm._s(_vm.couponDetail.couponCode))])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("点击二维码可刷新")]), _vm._v(" "), _c('div', {
    staticClass: "flex-col group_8"
  }, [_c('img', {
    staticClass: "image_4",
    attrs: {
      "src": _vm.couponDetail.qrCode
    },
    on: {
      "click": _vm.getDetail
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text_8"
  }, [_vm._v("到店出示二维码，请商家使用小免商户小程序扫描二维码，即可享受服务")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-col section_2"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "flex-col group_11"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "justify-between group_15"
  }, [_c('span', {
    staticClass: "text_19"
  }, [_vm._v("适用门店")]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('a', {
    staticClass: "text_20",
    attrs: {
      "href": _vm.couponDetail.toUseUrl
    }
  }, [_vm._v("查看详情")]), _vm._v(" "), _c('img', {
    staticClass: "image_5",
    attrs: {
      "src": "https://imgpub1.shouqiev.com/gofunplatform/files/20220819/mEyvglIEcJ.png"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-col group_17"
  }, [_c('span', {
    staticClass: "text_21"
  }, [_vm._v("使用说明")]), _vm._v(" "), _c('div', {
    staticClass: "flex-col group_18"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "flex-col section_3 footer"
  }, [_c('div', {
    staticClass: "flex-col items-center button"
  }, [_c('a', {
    staticClass: "text_23",
    attrs: {
      "href": _vm.couponDetail.toUseUrl
    }
  }, [_vm._v("去使用")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "justify-between group_9"
  }, [_c('span', {
    staticClass: "text_9"
  }, [_vm._v("服务类型")]), _vm._v(" "), _c('span', {
    staticClass: "text_10"
  }, [_vm._v("门店")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "justify-between group_10"
  }, [_c('span', {
    staticClass: "text_11"
  }, [_vm._v("服务项目")]), _vm._v(" "), _c('span', {
    staticClass: "text_12"
  }, [_vm._v("商务车普洗/SUV普洗/小轿车普洗")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "justify-between"
  }, [_c('span', {
    staticClass: "text_13"
  }, [_vm._v("优惠力度")]), _vm._v(" "), _c('span', {
    staticClass: "text_14"
  }, [_vm._v("免费洗车券")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "justify-between group_13"
  }, [_c('span', {
    staticClass: "text_15"
  }, [_vm._v("适用车型")]), _vm._v(" "), _c('span', {
    staticClass: "text_16"
  }, [_vm._v("商务车/SUV/小轿车")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "justify-between group_14"
  }, [_c('span', {
    staticClass: "text_17"
  }, [_vm._v("适用地域")]), _vm._v(" "), _c('span', {
    staticClass: "text_18"
  }, [_vm._v("全国")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "text_22"
  }, [_vm._v("\n                    1.本卷形式为电子卷，出示对应二维码即可使用；"), _c('br'), _vm._v("\n                    2.本卷必须在展示的有效期内使用，过期作废；"), _c('br'), _vm._v("\n                    3.本卷不兑现金，不找零，不可用于其他消费；"), _c('br'), _vm._v("\n                    4.本卷仅限适用地区合作洗车网点使用，网点详情查看商户列表；"), _c('br'), _vm._v("\n                    5.服务车辆限轿车，微型车，跑车，SUV等7座（含）以下车型；"), _c('br'), _vm._v("\n                    6.春节前后一个星期，全国合作商户将暂停提供服务；7.本卷最终解释权由GoFun 所有；"), _c('br')])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-e4466dca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-e4466dca","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/saleCar/coupon/couponDetail.vue
// module id = 287
// module chunks = 320 321